export default __webpack_public_path__ + "static/media/delivery.a6215d97.svg";